/** Time-to-live for drawer cache entries in milliseconds */
export const DRAWER_CACHE_TTL_MS = 60 * 1000; // 1 minute

/** Maximum number of entities to cache PER ENTITY TYPE (LRU eviction when exceeded) */
export const DRAWER_CACHE_MAX_PER_TYPE = 2;

/** Time-to-live for Gravatar cache entries in milliseconds */
export const GRAVATAR_CACHE_TTL_MS = 30 * 60 * 1000; // 30 minutes

/** Time-to-live for lookup field cache entries in milliseconds */
export const LOOKUP_CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
